import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-card-base',
  templateUrl: './card-base.component.html',
  styleUrls: ['./card-base.component.scss'],
  standalone: true,
  imports: [MatCardModule, NgIf, MatDividerModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule]
})
export class CardBaseComponent implements OnInit {
  @Input() title: string;
  @Input() hasFooter = true;
  @Input() hasSubmit = true;
  @Input() loading = false;
  @Input() isDisabled = false;
  @Input() submitText;
  @Input() hasActionDivider = false;
  @Input() actionAlignment: 'start' | 'end' | 'center' = 'center';
  @Output() onSubmitEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  actionCssClass = 'text-center';

  ngOnInit(): void {
    this.actionCssClass = 'action text-' + this.actionAlignment;
  }

  onSubmit(): void {
    if (!this.isDisabled) {
      this.onSubmitEvent.next(true);
    }
  }
}
